export default "__VITE_PUBLIC_ASSET__09a17a40__"